import React from 'react';
import './JournimLogo.css';

const JournimLogo = ({ className = '', style = {} }) => {
  return (
    <div className={`journim-logo-fallback ${className}`} style={style}>
      JOURNIM
    </div>
  );
};

export default JournimLogo;
